import { Grid } from '@mui/material';


// Components
import { AttachmentUsers } from '../../../../AttachmentUsers';
import { Alert } from '@mui/material';

// Styles
import {
  Container,
  Body,
  ContainerInfo,
} from '../styles'


// Utils
import { useTranslation } from 'react-i18next'

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../../../Context/PermissionsContext';

export const StepThree = ({
  data,
  validateEmail,
  handleFilesDrop,
  files
}) => {
  const ability = useAbility(AbilityContext);
  const { t } = useTranslation();

  return (
    <Container>
      <Body>
        <ContainerInfo style={{ overflowY: 'auto', overflowX: 'hidden', height: '100%', display: 'block' }}>
          <Grid container spacing={2}>
            {ability.can("UserAttachmentCreate") &&
              <>
                <Grid item xs={12}>
                  <Alert severity="warning" sx={{ mt: 1, mb: -1 }}>
                    {t('system.users.optionalStep')}
                  </Alert>
                </Grid>
                <Grid item xs={12} md={12} sx={{ marginTop: '5px' }}>
                  <AttachmentUsers 
                    id={data.id} 
                    disabled={false || validateEmail} 
                    onFilesDrop={handleFilesDrop}
                    externalFiles={files}
                  />
                </Grid>
              </>
            }
          </Grid>
        </ContainerInfo>
      </Body>
    </Container>
  )
}
